import { API_BASE_URL } from '../../../../lib/api';
import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../../lib/tenantHeaders';

/**
 * Catálogo de conceptos de cobro (flete, THC, seguro, OTM…).
 *
 * Los headers se construyen DENTRO de cada función y no a nivel de
 * módulo: hacerlo al importar congela el token y el slug del tenant de
 * la primera carga, y al cambiar de operador se siguen mandando los
 * viejos.
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });

export const fetchChargeConcepts = async ({
  limit = 10,
  offset = 1,
  query = {},
  sort,
} = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/charge-concepts/filter`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

/** Grupos y bases de cobro, para no duplicar los enums en el front. */
export const fetchChargeConceptOptions = async () => {
  const res = await apiFetch(`${API_BASE_URL}/charge-concepts/options`, {
    headers: withTenant(),
  });
  return res.json();
};

/**
 * Conceptos activos de un modo ('aereo' | 'lcl' | 'fcl'), ya ordenados
 * por grupo. Alimenta el combobox del editor de conceptos.
 */
export const fetchChargeConceptsByModo = async (modo) => {
  const res = await apiFetch(`${API_BASE_URL}/charge-concepts/by-modo/${modo}`, {
    headers: withTenant(),
  });
  return res.json();
};

export const createChargeConcept = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/charge-concepts`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateChargeConcept = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/charge-concepts/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteChargeConcept = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/charge-concepts/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

export const toggleChargeConceptStatus = async (id) => {
  const res = await apiFetch(
    `${API_BASE_URL}/charge-concepts/${id}/toggle-status`,
    { method: 'POST', headers: jsonHeaders() },
  );
  return res.json();
};

export const exportChargeConcepts = async ({ query = {}, sort } = {}) =>
  fetchChargeConcepts({ limit: 10000, offset: 1, query, sort });
